import { ApiError, apiClient } from 'shared/api';

import { CardRegistrationParamType, cartsResultType, getBillingCardsResponse } from '../model/dto';

export const getCarts = async (): Promise<cartsResultType> => {
  const { data } = await apiClient.get('/carts');

  return data.result;
};

export const getBillingCards = async ({
  userId,
  orderType,
}: CardRegistrationParamType): Promise<getBillingCardsResponse> => {
  const { data } = await apiClient.get(`/member/${userId}/billing-cards`, orderType ? { orderType } : undefined);

  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};
